import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const TextFieldComponent = (props: any) => {
    const [value, setValue] = useState('');
    
    useEffect(() => {
        if (props.model == null || props.field == null){
            return;
        }

        setValue(props.model[props.field] ?? '');
    }, [props.model]);

    function setModelEvent(value: any) {
        setValue(value);

        if (props.textFieldChangedCallback!=null) {
            props.textFieldChangedCallback(props.field, value);
        }

        if (props.model == null || props.field == null){
            return;
        }
        
        props.model[props.field] = value;
    }

    return (
        <div className={props.divClassName}>
            <TextField
                fullWidth
                className={props.className}
                required={props.required}
                disabled={props.disabled ?? false}
                onChange={(e: any) => setModelEvent(e.target.value)} 
                label={props.label}
                value={value}
                variant={props.variant ?? "outlined"}
                type={props.type ?? 'text'}
                inputProps={props.inputProps}
                style={{ marginRight: 10 }} />
        </div>
    )
}

export default TextFieldComponent